import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MerchandiseGroupComponent } from './merchandise-group.component';
import { PolylineModule } from '@finder/shared/components/polyline/polyline.module';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { PictureModule } from '@finder/shared/components/picture/picture.module';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';
import { RevealContentModule } from '@finder/shared/components/reveal-content/reveal-content.module';

@NgModule({
    declarations: [
        MerchandiseGroupComponent
    ],
    imports: [
        PolylineModule,
        AnchorModule,
        SafeHtmlPipeModule,
        PictureModule,
        RevealContentModule,
        CommonModule
    ],
    exports: [
        MerchandiseGroupComponent
    ]
})
export class MerchandiseGroupModule { }
